import React, { Component } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

class DayInput extends Component {
  componentWillReceiveProps(nextProps) {
    const { field, monthSelected, yearSelected } = this.props;
    const { onChange } = field;

    // Se o mês mudou, resetar o valor
    if (
      nextProps.monthSelected.value !== monthSelected.value ||
      nextProps.yearSelected.value !== yearSelected.value
    ) {
      onChange(field.initialValue || "");
    }
  }

  isLeapYear(yearSelected) {
    return (
      yearSelected % 4 === 0 &&
      (yearSelected % 100 !== 0 || yearSelected % 400 === 0)
    );
  }

  getDaysInMonth(monthSelected, yearSelected) {
    switch (monthSelected.value) {
      case "01":
      case "03":
      case "05":
      case "07":
      case "08":
      case "10":
      case "12":
        return 31;
      case "04":
      case "06":
      case "09":
      case "11":
        return 30;
      case "02":
        return this.isLeapYear(yearSelected.value) ? 29 : 28;
      default:
        return 31;
    }
  }

  render() {
    const { disabled, text, field, monthSelected, yearSelected } = this.props;
    const { touched, error, value, onChange } = field;

    const maxDays = this.getDaysInMonth(monthSelected, yearSelected);
    const days = [];
    for (let i = 1; i <= maxDays; i++) {
      const day = i < 10 ? "0" + i : "" + i;
      days.push(
        <option key={day} value={day}>
          {day}
        </option>
      );
    }

    const formControlClass = classnames("form-control select-input-large", {
      placeholder: !value,
    });
    const formGroupClass = classnames("form-group", {
      "has-error": touched && error,
    });

    const isDisabled = disabled || !monthSelected.value || !yearSelected.value;

    return (
      <div className={formGroupClass}>
        <select
          disabled={isDisabled}
          value={value || field.initialValue || ""}
          onChange={e => onChange(e.target.value)}
          className={formControlClass}
        >
          <option value="" disabled>
            {text.day}
          </option>
          {days}
        </select>
        {touched && error && <div className="help-block">{error}</div>}
      </div>
    );
  }
}

DayInput.propTypes = {
  disabled: PropTypes.bool,
  field: PropTypes.object.isRequired,
  text: PropTypes.object.isRequired,
  monthSelected: PropTypes.object.isRequired,
  yearSelected: PropTypes.object.isRequired,
};

export default DayInput;



// WEBPACK FOOTER //
// ./src/components/DayInput.js